import React, { createContext, useContext, useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { useLocalStorage } from "../hooks/useLocalStorage";

const ThemeContext = createContext();

export function useDfrTheme() {
    return useContext(ThemeContext);
}

export function DfrThemeProvider({ children }) {
    const [mode, setMode] = useLocalStorage("theme", "dark");
    const theme = useMemo(() => createTheme(Themes[mode]), [mode]);

    const values = {
        mode,
        setMode
    };

    return (
        <ThemeContext.Provider value={values}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </ThemeContext.Provider>
    );
}

const Themes = {
    dark: {
        palette: {
            mode: "dark",
            background: {
                toolbar: "#090a0e",
                sidebar: "#151618",
                dashboard: "#111212",
                map: "#151618"
            }
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        "&.Mui-disabled": {
                            WebkitTextFillColor: "rgba(255, 255, 255, 0.9)"
                        }
                    }
                }
            }
        }
    },
    light: {
        palette: {
            mode: "light",
            background: {
                toolbar: "#5e95ca",
                sidebar: "#eff4ff",
                dashboard: "#FFF",
                map: "#dae6f7"
            },
            text: {
                secondary: "#000"
            }
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        "&.Mui-disabled": {
                            WebkitTextFillColor: "rgba(0, 0, 0, 0.9)"
                        }
                    }
                }
            }
        }
    }
};
